// @flow
import moment from 'moment'
import is from './is'

/**
 * Function that clones given value with respect to the timezone.
 * Returns new instance of moment object.
 * @param  {string|moment} val
 * @return {moment}
 */
const cloneDatetime = (val: ?string | moment): moment => {
  if (!val) return moment()
  if (is.string(val)) return moment.parseZone(val)
  return (val: moment).clone()
}

export default cloneDatetime
